(function() {
  window.utils = {
    //Not ideal but to handle different typs of clicking on cards
    //To prevent click fron happending is tyring to do a long click
    onHold: false,
    isDev() {
      return window.location.host !== "sgtwoofy.com";
    },
    requests: {
      send: function({type, url, headers = {}, callback}) {
        $.ajax({
          type: type,
          dataType: 'json',
          url: url,  
          headers: headers,
          success: function(result){
            callback(result);
          }
        });
      },
      getHeaders: function({token}) {
        return {
          'Client-ID': clientId,
          'Authorization': `Bearer ${token}`
        };
      }
    },
    rand(min, max) {
      return Math.floor(Math.random() * (max + 1)) + min;
    },
    url: {
      params: function({url}) {
        let paramsObject = {};
        let params = url.split('?')[1].split('&');
        for (let param of params) {
          let p = param.split('=');
          paramsObject[`${p[0]}`] = p[1];
        }
        return paramsObject;
      },
      param: function({url, name}) {
        let params = utils.url.params({url: url});
        return params[`${name}`] ? params[name] : null;
      }
    },
    cookies: {
      has(name) {
        return !!this.get(name);
      },
      get(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return decodeURI(c.substring(nameEQ.length, c.length));
        }
        return null;
      },
      set(name, value, days) {
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          var expires = "; expires=" + date.toGMTString();
        } else {
          var expires = "";
        }
        //Adds the SameSite stuff for production. Adding it to dev breaks the dev site.
        let sameSite = window.location.hostname == 'localhost' ? '' : 'SameSite=None; Secure;';
        document.cookie = `${name}=${encodeURI(value) + expires}; ${sameSite} path=/`;
      },
      delete(name) {
        this.set(name, '', -1);
      },
      deleteAll() {
        var cookies = document.cookie.split(";");
    
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            this.set(name, '', -1);
        }
      }
    },
    alert: {
      show(text, type) {
        let $alert = $(`<div class="alert -${type}">${text}</div>`);

        $('.alert').remove();
        $('body').append($alert);

        setTimeout(function() {
          $alert.addClass('show');

          setTimeout(function() {
            utils.alert.hide();
          }, 6000);
        }, 200);

      },
      error(text) {
        utils.alert.show(text, 'error');
      },
      success(text) {
        utils.alert.show(text, 'success');
      },
      hide() {
        let $alert = $('.alert');
        $alert.removeClass('show');

        setTimeout(function() {
          $alert.remove();
        }, 1000);
      },
    },
    arrayIsUnique: function(arr) {
      let sorted_arr = arr.slice().sort(); // You can define the comparing function here. 
      // JS by default uses a crappy string compare.
      // (we use slice to clone the array so the
      // original array won't be modified)
      let results = [];
      for (let i = 0; i < sorted_arr.length - 1; i++) {
        if (sorted_arr[i + 1] == sorted_arr[i]) {
          results.push(sorted_arr[i]);
        }
      }
      return results.length ? false : true;
    },
    doesFileExist: function(urlToFile) {
      var xhr = new XMLHttpRequest();
      xhr.open('HEAD', urlToFile, false);
      xhr.send();
       
      if (xhr.status == "404") {
          return false;
      } else {
          return true;
      }
    },
    explosion: function() {
      let particles = 200;
      // explosion container and its reference to be able to delete it on animation end
      let explosion = $('<div class="explosion"></div>');

      // put the explosion container into the body to be able to get it's size
      $('body').prepend(explosion);

      // position the container to be centered on click
      explosion.css('left', 0);
      explosion.css('top', 0);

      for (let i = 0; i < particles; i++) {
        // positioning x,y of the particle on the circle (little randomized radius)
        let x = (explosion.width() / 2) + utils.rand(80, window.outerWidth * .4) * Math.cos(2 * Math.PI * i / utils.rand(particles - 10, particles + 10));
        let y = (explosion.height() / 2) + utils.rand(80, window.outerHeight * .4) * Math.sin(2 * Math.PI * i / utils.rand(particles - 10, particles + 10));
        // let color = utils.rand(0, 255) + ', ' + utils.rand(0, 255) + ', ' + utils.rand(0, 255);
        let size = utils.rand(0, 20) + 10;

        let random = utils.rand(0, 3) + 1;
        let image;
        switch(random) {
          case 1:
            image = 'gold-paw.png';
            break;
          case 2:
            image = 'white-paw.png';
            break;
          case 3:
            image = 'red-paw.png';
            break;
          case 4:
            image = 'blue-paw.png';
            break;
          default:
            // code block
        }

            // particle element creation (could be anything other than div)
          elm = $('<div class="particle" style="' +
            'width: ' + size + 'px; ' +
            'height: ' + size + 'px; ' +
            'background-image: url(/images/' + image + '); ' +
            // 'background-color: rgb(' + color + ') ;' +
            'top: ' + y + 'px; ' +
            'left: ' + x + 'px"></div>');

        if (i == 0) { // no need to add the listener on all generated elements
          elm.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(e) {
            explosion.remove(); // remove this explosion container when animation ended
          });
        }
        explosion.append(elm);
      }
    }
  }

  window.searchResultsNames = [];
  Vue.config.productionTip = false;
  Vue.config.devtools = false;

  $(document).ready(function() {

    // $('[data-toggle="popover"]').popover({
    //   content: 'Please be aware it may not always work as expected.',
    //   trigger: 'hover',
    //   placement: 'bottom'
    // });

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    // function supportsHEVCAlpha() {
    //   const navigator = window.navigator;
    //   const ua = navigator.userAgent.toLowerCase()
    //   const hasMediaCapabilities = !!(navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo)
    //   const isSafari = ((ua.indexOf('safari') != -1)&& (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1)))
  
    //   return isSafari && hasMediaCapabilities
    // }
    
    // function isIE11() {
    //     return !!window.navigator.userAgent.match(/Trident\/7\./,[]);
    // }
    
    // if (!isIE11()) {
    //     const player = document.getElementById('player');
    //     player.src = supportsHEVCAlpha() ? '/videos/test2.mov': '/videos/test2.webm';
    // } 

  });

  //Timer code if we want to use it
  // $('body').append('<div class="clock"><label id="minutes">00</label>:<label id="seconds">00</label></div>');

  // var minutesLabel = document.getElementById("minutes");
  // var secondsLabel = document.getElementById("seconds");
  // var totalSeconds = 0;
  // setInterval(setTime, 1000);
  
  // function setTime() {
  //   ++totalSeconds;
  //   secondsLabel.innerHTML = pad(totalSeconds % 60);
  //   minutesLabel.innerHTML = pad(parseInt(totalSeconds / 60));
  // }
  
  // function pad(val) {
  //   var valString = val + "";
  //   if (valString.length < 2) {
  //     return "0" + valString;
  //   } else {
  //     return valString;
  //   }
  // }

})();